// @flow

import locationDisplay from './locationDisplay';

export default locationDisplay;
